import Vue from 'vue';
import VueRouter from 'vue-router';

import Home from '@/routes/Home.vue';
import Brand from '@/routes/Brand.vue';
import About from '@/routes/About.vue';
import Contact from '@/routes/Contact.vue';
import Product from '@/routes/Product.vue';
import NotFound from '@/routes/NotFound.vue';

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		name: 'Milano Leather',
		component: Home,
	},
	{
		path: '/brand/:brand/',
		name: 'Brand',
		component: Brand,
	},
	{
		path: '/about/',
		name: 'About',
		component: About,
	},
	{
		path: '/contact/',
		name: 'Contact',
		component: Contact,
	},
	{
		path: '/product/:brand/:category/:sku/:colour?',
		name: 'Product',
		component: Product,
	},
	{
		path: '*',
		name: 'The page you are looking for was not found',
		component: NotFound,
	},
]

export default new VueRouter({
	routes,
	mode: 'history',
});
